document.addEventListener('DOMContentLoaded', function() {
    const form = document.querySelector('form[action="/account/recover"]');
    const emailInput = document.getElementById('RecoverEmail');
    const errorMessage = document.createElement('p');
    errorMessage.id = 'RecoverEmail-email-error';
    errorMessage.classList.add('form__message');

    const errorImage = document.createElement('img');
    errorImage.src = errorImageInfo;
    errorImage.style.display = 'none'; 
    errorImage.style.marginRight = '5px'; 
    
    errorMessage.appendChild(errorImage);
    emailInput.parentNode.appendChild(errorMessage);

    form.addEventListener('submit', function(event) {
        let email = emailInput.value;
        if (email === '') {
            showErrorMessage(errorMessage, errorImage, 'Please enter your email.');
            emailInput.setAttribute('aria-invalid', 'true');
            emailInput.style.border = '1px solid rgba(240, 84, 80, 1)'; 
            event.preventDefault();
        } else if (!email.includes('@')) {
            showErrorMessage(errorMessage, errorImage, 'No account found with that email');
            emailInput.setAttribute('aria-invalid', 'true');
            event.preventDefault();
            emailInput.style.border = '1px solid rgba(240, 84, 80, 1)'; 
        } else {
            clearErrorMessage(errorMessage, errorImage);
            emailInput.removeAttribute('aria-invalid');
            emailInput.style.border = '1px solid  rgba(194, 194, 194, 1)'; 
        }
    });

    emailInput.addEventListener('input', function() {
        clearErrorMessage(errorMessage, errorImage);
        emailInput.removeAttribute('aria-invalid');
        emailInput.style.border = '1px solid  rgba(194, 194, 194, 1)'; 
    });
});

const showErrorMessage = (errorMessage, errorImage, message) => {
    errorImage.style.display = 'inline'; 
    errorMessage.innerHTML = ''; 
    errorMessage.appendChild(errorImage);
    errorMessage.appendChild(document.createTextNode(message));
}

const clearErrorMessage = (errorMessage, errorImage) => {
    errorMessage.innerHTML = ''; 
    errorImage.style.display = 'none'; 
}


document.addEventListener('DOMContentLoaded', function() {
    const passwordInput = document.getElementById('CustomerPassword');
    const showPassword = document.getElementById('show-password');
    const hidePassword = document.getElementById('hide-password');

    hidePassword.addEventListener('click', function() {
      passwordInput.type = 'text';  
      hidePassword.style.display = 'none'; 
      showPassword.style.display = 'inline';
    });

    showPassword.addEventListener('click', function() {
      passwordInput.type = 'password';  
      showPassword.style.display = 'none'; 
      hidePassword.style.display = 'inline'; 
    });
  });